// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { getMe, getMeGetConfig, getMeGetRamdomRewardHistory, getMeGetTop, getMissionGetTop, getParamByIds, type Options, postMeCheckIn, postMeClaim, postMeClaimAccumulateReward, postMeClaimMilestoneReward, postMeContribute, postMeShare, postMeSubmitInviteCode, postMeUpdateMiniGameResult, postMeUpdateShipDetail, postMissionImportFishData, postMissionUpdateMissionStatus } from '../sdk.gen';
import type { GetMeData, GetMeGetConfigData, GetMeGetConfigResponse, GetMeGetRamdomRewardHistoryData, GetMeGetRamdomRewardHistoryResponse, GetMeGetTopData, GetMeGetTopResponse, GetMeResponse, GetMissionGetTopData, GetMissionGetTopResponse, GetParamByIdsData, GetParamByIdsResponse, PostMeCheckInData, PostMeCheckInResponse, PostMeClaimAccumulateRewardData, PostMeClaimAccumulateRewardResponse, PostMeClaimData, PostMeClaimMilestoneRewardData, PostMeClaimMilestoneRewardResponse, PostMeClaimResponse, PostMeContributeData, PostMeContributeResponse, PostMeShareData, PostMeShareResponse, PostMeSubmitInviteCodeData, PostMeSubmitInviteCodeResponse, PostMeUpdateMiniGameResultData, PostMeUpdateMiniGameResultResponse, PostMeUpdateShipDetailData, PostMeUpdateShipDetailResponse, PostMissionImportFishDataData, PostMissionImportFishDataResponse, PostMissionUpdateMissionStatusData, PostMissionUpdateMissionStatusResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getParamByIdsQueryKey = (options: Options<GetParamByIdsData>) => createQueryKey('getParamByIds', options);

/**
 * Common params
 */
export const getParamByIdsOptions = (options: Options<GetParamByIdsData>) => queryOptions<GetParamByIdsResponse, DefaultError, GetParamByIdsResponse, ReturnType<typeof getParamByIdsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getParamByIds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getParamByIdsQueryKey(options)
});

export const getMeQueryKey = (options?: Options<GetMeData>) => createQueryKey('getMe', options);

export const getMeOptions = (options?: Options<GetMeData>) => queryOptions<GetMeResponse, DefaultError, GetMeResponse, ReturnType<typeof getMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeQueryKey(options)
});

export const getMeGetConfigQueryKey = (options?: Options<GetMeGetConfigData>) => createQueryKey('getMeGetConfig', options);

export const getMeGetConfigOptions = (options?: Options<GetMeGetConfigData>) => queryOptions<GetMeGetConfigResponse, DefaultError, GetMeGetConfigResponse, ReturnType<typeof getMeGetConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMeGetConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeGetConfigQueryKey(options)
});

export const postMeContributeMutation = (options?: Partial<Options<PostMeContributeData>>): UseMutationOptions<PostMeContributeResponse, DefaultError, Options<PostMeContributeData>> => {
    const mutationOptions: UseMutationOptions<PostMeContributeResponse, DefaultError, Options<PostMeContributeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMeContribute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMeUpdateShipDetailMutation = (options?: Partial<Options<PostMeUpdateShipDetailData>>): UseMutationOptions<PostMeUpdateShipDetailResponse, DefaultError, Options<PostMeUpdateShipDetailData>> => {
    const mutationOptions: UseMutationOptions<PostMeUpdateShipDetailResponse, DefaultError, Options<PostMeUpdateShipDetailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMeUpdateShipDetail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMeGetRamdomRewardHistoryQueryKey = (options?: Options<GetMeGetRamdomRewardHistoryData>) => createQueryKey('getMeGetRamdomRewardHistory', options);

export const getMeGetRamdomRewardHistoryOptions = (options?: Options<GetMeGetRamdomRewardHistoryData>) => queryOptions<GetMeGetRamdomRewardHistoryResponse, DefaultError, GetMeGetRamdomRewardHistoryResponse, ReturnType<typeof getMeGetRamdomRewardHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMeGetRamdomRewardHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeGetRamdomRewardHistoryQueryKey(options)
});

export const postMeSubmitInviteCodeMutation = (options?: Partial<Options<PostMeSubmitInviteCodeData>>): UseMutationOptions<PostMeSubmitInviteCodeResponse, DefaultError, Options<PostMeSubmitInviteCodeData>> => {
    const mutationOptions: UseMutationOptions<PostMeSubmitInviteCodeResponse, DefaultError, Options<PostMeSubmitInviteCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMeSubmitInviteCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMeCheckInMutation = (options?: Partial<Options<PostMeCheckInData>>): UseMutationOptions<PostMeCheckInResponse, DefaultError, Options<PostMeCheckInData>> => {
    const mutationOptions: UseMutationOptions<PostMeCheckInResponse, DefaultError, Options<PostMeCheckInData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMeCheckIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMeShareMutation = (options?: Partial<Options<PostMeShareData>>): UseMutationOptions<PostMeShareResponse, DefaultError, Options<PostMeShareData>> => {
    const mutationOptions: UseMutationOptions<PostMeShareResponse, DefaultError, Options<PostMeShareData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMeShare({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMeClaimMutation = (options?: Partial<Options<PostMeClaimData>>): UseMutationOptions<PostMeClaimResponse, DefaultError, Options<PostMeClaimData>> => {
    const mutationOptions: UseMutationOptions<PostMeClaimResponse, DefaultError, Options<PostMeClaimData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMeClaim({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMeClaimAccumulateRewardMutation = (options?: Partial<Options<PostMeClaimAccumulateRewardData>>): UseMutationOptions<PostMeClaimAccumulateRewardResponse, DefaultError, Options<PostMeClaimAccumulateRewardData>> => {
    const mutationOptions: UseMutationOptions<PostMeClaimAccumulateRewardResponse, DefaultError, Options<PostMeClaimAccumulateRewardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMeClaimAccumulateReward({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMeClaimMilestoneRewardMutation = (options?: Partial<Options<PostMeClaimMilestoneRewardData>>): UseMutationOptions<PostMeClaimMilestoneRewardResponse, DefaultError, Options<PostMeClaimMilestoneRewardData>> => {
    const mutationOptions: UseMutationOptions<PostMeClaimMilestoneRewardResponse, DefaultError, Options<PostMeClaimMilestoneRewardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMeClaimMilestoneReward({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMeUpdateMiniGameResultMutation = (options?: Partial<Options<PostMeUpdateMiniGameResultData>>): UseMutationOptions<PostMeUpdateMiniGameResultResponse, DefaultError, Options<PostMeUpdateMiniGameResultData>> => {
    const mutationOptions: UseMutationOptions<PostMeUpdateMiniGameResultResponse, DefaultError, Options<PostMeUpdateMiniGameResultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMeUpdateMiniGameResult({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMeGetTopQueryKey = (options: Options<GetMeGetTopData>) => createQueryKey('getMeGetTop', options);

export const getMeGetTopOptions = (options: Options<GetMeGetTopData>) => queryOptions<GetMeGetTopResponse, DefaultError, GetMeGetTopResponse, ReturnType<typeof getMeGetTopQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMeGetTop({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeGetTopQueryKey(options)
});

export const postMissionUpdateMissionStatusMutation = (options?: Partial<Options<PostMissionUpdateMissionStatusData>>): UseMutationOptions<PostMissionUpdateMissionStatusResponse, DefaultError, Options<PostMissionUpdateMissionStatusData>> => {
    const mutationOptions: UseMutationOptions<PostMissionUpdateMissionStatusResponse, DefaultError, Options<PostMissionUpdateMissionStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMissionUpdateMissionStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Import daily FishRecord data
 *
 * Import up to 20000 full FishRecord snapshot rows after Config_FishRecord/delete_all. Each vopenid must be unique.
 */
export const postMissionImportFishDataMutation = (options?: Partial<Options<PostMissionImportFishDataData>>): UseMutationOptions<PostMissionImportFishDataResponse, DefaultError, Options<PostMissionImportFishDataData>> => {
    const mutationOptions: UseMutationOptions<PostMissionImportFishDataResponse, DefaultError, Options<PostMissionImportFishDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMissionImportFishData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMissionGetTopQueryKey = (options?: Options<GetMissionGetTopData>) => createQueryKey('getMissionGetTop', options);

/**
 * Get the top 10 fishers and the logged-in user's rank
 */
export const getMissionGetTopOptions = (options?: Options<GetMissionGetTopData>) => queryOptions<GetMissionGetTopResponse, DefaultError, GetMissionGetTopResponse, ReturnType<typeof getMissionGetTopQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMissionGetTop({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMissionGetTopQueryKey(options)
});
